import type { App as VueApp, Plugin } from "vue";

// Components

import AccountLogin from "@Account/Scripts/Components/Account/AccountLogin.vue";
import AccountLogout from "@Account/Scripts/Components/Account/AccountLogout.vue";
import AccountRegister from "@Account/Scripts/Components/Account/AccountRegister.vue";
import AccountEmailConfirmSend from "@Account/Scripts/Components/Account/AccountEmailConfirmSend.vue";
import AccountPasswordRemind from "@Account/Scripts/Components/Account/AccountPasswordRemind.vue";
import AccountPasswordReset from "@Account/Scripts/Components/Account/AccountPasswordReset.vue";
import AccountUserInfo from "@Account/Scripts/Components/Account/AccountUserInfo.vue";
import AccountExternalRegister from "@Account/Scripts/Components/Account/AccountExternalRegister.vue";
import AccountProfileEdit from "@Account/Scripts/Components/Account/AccountProfileEdit.vue";
import AccountProfileSegmentEdit from "@Account/Scripts/Components/Account/AccountProfileSegmentEdit.vue";
import Footer from "@Account/Scripts/Components/Footer/Footer.vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";

const AppConfig: Plugin = {
    install(app: VueApp) {
        app.component("app-accountlogin", AccountLogin);
        app.component("app-accountlogout", AccountLogout);
        app.component("app-accountregister", AccountRegister);
        app.component("app-accountemailconfirmsend", AccountEmailConfirmSend);
        app.component("app-accountpasswordremind", AccountPasswordRemind);
        app.component("app-accountpasswordreset", AccountPasswordReset);
        app.component("app-accountuserinfo", AccountUserInfo);
        app.component("app-accountexternalregister", AccountExternalRegister);
        app.component("app-accountprofileedit", AccountProfileEdit);
        app.component("app-accountprofilesegmentedit", AccountProfileSegmentEdit);
        app.component("app-footer", Footer);

        app.component("app-cookietoast", CookieToast);
    }
};

export default AppConfig;